import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "./auth/auth.guard";
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { UsersComponent } from './auth/users/users.component';
import { UserDetailComponent } from './auth/users/detail/user-detail.component';
import { GroupsComponent } from './auth/groups/groups.component';
import { GroupDetailComponent } from './auth/groups/group-detail/group-detail.component';
import { StockComponent } from './assets/stock/stock.component';
import { HistoryComponent } from './assets/history/history.component';
import { NotlocatedComponent } from './assets/notlocated/notlocated.component';
import { StockSummarizedComponent } from './assets/stock/stock-summarized.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { MovementsAuditoryComponent } from './assets/auditory/movement-auditory.component';
import { MovementsDetailComponent } from './assets/auditory/movement-detail.component';
import { LocationsComponent } from './assets/locations/locations.component';
import { LocationDetailComponent } from './assets/locations/detail/location-detail/location-detail.component';

const routes: Routes = [
 { path: 'home', component: HomeComponent, canActivate: [ AuthGuard ],
   data: { title: 'Dashboard' },
   children: []
 },
 { path: 'assets/stock', component: StockComponent, canActivate: [AuthGuard],
   data: { title: 'Consulta de stock' },
   children: []
 },
 { path: 'assets/not-located', component: NotlocatedComponent, canActivate: [AuthGuard],
   data: { title: 'Activos sin ubicación' },
   children: []
 },
 { path: 'assets/summarized', component: StockSummarizedComponent, canActivate: [AuthGuard],
   data: { title: 'Gráfica de stock' },
   children: []
 },
 { path: 'assets/movements',
   data: { title: 'Historial de movimientos' },
   children: [
   { path: '', component: MovementsAuditoryComponent, canActivate: [AuthGuard]},
   { path: ':id', component: MovementsDetailComponent, canActivate: [AuthGuard], data: {title: 'Detalle del movimiento'}, children: []}
   ]
 },
 { path: 'assets/:serialnumber', component: HistoryComponent, canActivate: [AuthGuard],
   data: { title: 'Detalle de un activo' },
   children: []
 },
 { path: 'users',
   data: { title: 'Gestión de usuarios' },
   children: [
    {path: '', component: UsersComponent, canActivate: [ AuthGuard ]},
    { path: 'detail/:id', component: UserDetailComponent, canActivate: [ AuthGuard ], data: { title: 'Detalle del usuario' } }   ,
    { path: 'new', component: UserDetailComponent, canActivate: [ AuthGuard ], data: { title: 'Creación del usuario' } }   
   ]
 },
{ path: 'groups',
   data: { title: 'Gestión de perfiles' },
   children: [
    { path: '', component: GroupsComponent, canActivate: [ AuthGuard ]} ,
    { path: 'detail/:id', component: GroupDetailComponent, canActivate: [ AuthGuard ], data: { title: 'Detalle del perfil' } },
    { path: 'new', component: GroupDetailComponent, canActivate: [ AuthGuard ], data: { title: 'Creación del perfil' } }
   ]
 },   
 { path: 'user-guide', component: UserGuideComponent, canActivate: [ AuthGuard ], 
   data: { title: 'Manual de uso' },
   children: []
 },
 { path: 'locations',
   data: { title: 'Gestión de ubicaciones' },
   children: [
      { path: '', component: LocationsComponent, canActivate: [ AuthGuard ]},
      { path: 'detail/:id', component: LocationDetailComponent, canActivate: [ AuthGuard ], data: { title: 'Detalle de ubicación' } }   ,
      { path: 'new', component: LocationDetailComponent, canActivate: [ AuthGuard ], data: { title: 'Creación de ubicación' } }
   ]
 }, 
 { path: 'login', component: LoginComponent, data: {customLayout: true} },
 { path: '', redirectTo: '/home', pathMatch: 'full' },  
 { path: '**', redirectTo: '/home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
